var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-pagination"},[_c('base-container',[_c('nav',[_c('ul',{staticClass:"pagination-list"},_vm._l((_vm.length),function(item,i){return _c('li',{key:i,staticClass:"pagination-item",class:{
						active: i === _vm.activeSlide
					},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('goToHandler', i)}}})}),0)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }